import { system } from '../config/system'
import { GenericalRecord } from '../types/utilities'

import { parseUrl, stringifyUrl } from './querystring'
import { isHttpUrl } from './url'

/**
 * 是否在白名单内可以直接访问
 */
export const withinWhitelist = () => {
  return system.router.whitelist.some(item =>
    window.location.pathname.includes(item)
  )
}

/**
 * 给目标地址添加重定向参数
 *
 * @param to 重定向的目标地址
 * @param query url query 参数
 * @returns 带参数的地址
 */
export const setRedirectUrl = (to: string, query?: GenericalRecord) => {
  const targetPath = isHttpUrl(to)
    ? window.location.href
    : window.location.href.replace(window.location.origin, '')
  const existedTargetParam = parseUrl(window.location.href).query.target
  return stringifyUrl({
    url: to,
    query: {
      target: existedTargetParam || targetPath,
      ...query
    }
  })
}

/**
 * 获取重定向的目标地址
 *
 * @returns 地址
 */
export const getRedirectUrl = () => {
  const { query } = parseUrl(window.location.href)
  return (query.target as string) || '/'
}

/**
 * 使用刷新页面的方式进行跳转
 *
 * @param target 重定向地址
 */
export const browserRedirect = (target?: string) => {
  window.location.href = target || getRedirectUrl()
}

/**
 * 浏览器刷新页面
 */
export const browserReload = () => {
  window.location.reload()
}

/**
 * 浏览器打开页面
 */
export const browserOpen = window.open
